import request from '@/utils/request'

// 超管概览页
// 批次数
export const getBatchNum = () => {
  return request({
    url: '/trace/org/index/batch/num'
  })
}

// 当年销售情况排名
export const getMerchantReport = () => {
  return request({
    url: '/trace/org/index/merchant/report'
  })
}

// 订单报表
export const getOrderReport = () => {
  return request({
    url: '/trace/org/index/order/report'
  })
}

// 产品 总数、在产数、停产
export const getProductNum = () => {
  return request({
    url: '/trace/org/index/product/num'
  })
}

// 溯源码 总数、已打印、未打印
export const getQrcodeNum = () => {
  return request({
    url: '/trace/org/index/qrcode/num'
  })
}

// 人员总数
export const getUserNum = () => {
  return request({
    url: '/trace/org/index/user/num'
  })
}
